import { render } from 'preact';
import App from './app.jsx';
import { initInstallPrompt } from './lib/install.js';
import './styles/theme.css';

// Before render(), deliberately: Chrome can fire `beforeinstallprompt`
// earlier than the first component effect on a warm service-worker cache,
// and an event nobody was listening for is lost for the whole page load.
initInstallPrompt();

render(<App />, document.getElementById('etm-root'));
